// extracted by mini-css-extract-plugin
export default {"container":"Branches_container__VadMZ","branch_card":"Branches_branch_card__ceCr4","branch_info":"Branches_branch_info__DtWfr"};